import EnqueryForm from "@/components/forms/EnqueryForm";
import { FormHeading, SuccessMessageType } from "@/interface/types";
import Image from "next/image";

const BridgeContact = () => {
  return (
    <>
      <div className="mx-auto h-auto w-full pt-10 md:pb-[50px] md:pt-[80px] pb-0 relative md:bg-[#FFF] bg-[#061A2F]">
        <div className="lg:container mx-auto px-5 lg:px-6 xl:px-10 2xl:px-0 z-10 relative text-[#030F1C]">
          {/* desktop */}
          <div className="flex flex-col md:flex-row md:gap-2 relative">
            <div className="md:block hidden">
              <div className="flex flex-row md:flex-row md:gap-6 gap-[20px] md:pt-[10px] pb-[65px] md:mt-10 relative">
                <div className="w-full md:text-left text-center">
                  <p className="font-bold text-[24px] md:text-[32px] leading-[26px] md:leading-[40px] md:text-[#09284A] md:mb-3 md:block hidden">
                    Indian B.Com/BBA Graduates can now <br />
                    appear for the CPA exam immediately
                    <br /> after their under-graduation*
                    <span className="font-semibold text-[14px] md:text-[14px] leading-[26px] md:leading-[20px] text-[#000] md:mt-4 md:block hidden">
                      *If you submit enrolment proof for the above approved
                      programs
                    </span>
                  </p>
                  <p className="text-sm font-semibold text-[#000] mt-4">
                    For admissions or admission related queries please send an
                    email to{" "}
                    <a
                      className="underline text-[#3174d6]"
                      href="mailto:admissions.bridgecourse@mileseducation.com"
                    >
                      admissions.bridgecourse@mileseducation.com
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div className="md:w-1/2 w-full mt-2 md:mt-0 md:block hidden">
              <div className="mx-36 w-full max-w-[440px] py-2 bg-white rounded-2xl px-5 md:px-4 border border-white shadow-md shadow-blue-300">
                <EnqueryForm
                  courseId={9}
                  darkBackground={false}
                  formHeading={FormHeading.TALK_TO_AN_EXPERT}
                  formType="Bridge Course Form"
                  submitButtonName="Download Brochure"
                  successMessage={SuccessMessageType.ACCOUNTING}
                />
              </div>

              <div className="md:hidden flex flex-col items-center mt-16">
                <Image
                  src="/images/business/strategic-finance/lines.png"
                  alt="Phone Icon"
                  className="ml-[20px]"
                  width={1}
                  height={45}
                />
              </div>
            </div>
            {/* mobile */}
            <div className="md:hidden block">
              <div>
                <h2 className="text-[28px] font-bold text-center text-[#FDBD1A] leading-[1.3] md:hidden block">
                  Indian B.Com/BBA
                  <br /> Graduates can now
                  <br /> appear for the CPA exam
                  <br /> immediately after their
                  <br /> under-graduation*
                </h2>
              </div>
              <div className="bg-white rounded-[15px] soba_foot_sha md:hidden block mt-8">
                <div className="flex flex-col md:flex-row md:gap-5 gap-[20px] pt-[0px] relative">
                  <div className="md:w-1/2 w-full  md:mt-0">
                    <div className="mx-auto w-full max-w-[567px] py-10 bg-white rounded-lg shadow-[109.683px_145.137px_50.964px_0px_rgba(4,84,175,0),70.906px_93.065px_46.532px_0px_rgba(4,84,175,0.01),39.885px_52.072px_38.777px_0px_rgba(4,84,175,0.05),17.727px_23.266px_28.806px_0px_rgba(4,84,175,0.09),4.432px_5.54px_15.511px_0px_rgba(4,84,175,0.1)] px-5 md:px-10">
                      <EnqueryForm
                        courseId={9}
                        darkBackground={false}
                        formHeading={FormHeading.TALK_TO_AN_EXPERT}
                        formType="Bridge Course Form"
                        submitButtonName="Download Brochure"
                        successMessage={SuccessMessageType.ACCOUNTING}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center mt-4">
                <p className="text-white text-[14px]">
                  *If you submit enrolment proof for the above
                  <br /> approved programs
                </p>
                <p className="text-sm font-semibold text-white mt-4 mb-10">
                  For admissions or admission related queries please send an
                  email to{" "}
                  <a
                    className="underline text-[#FDBD1A]"
                    href="mailto:admissions.bridgecourse@mileseducation.com"
                  >
                    admissions.bridgecourse@mileseducation.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BridgeContact;
